import { Box, Flex, Text } from '@chakra-ui/react';
import Link from '~/components/Link';
import { InfoCircleIcon } from '~/components/icons/components/InfoCircleIcon';
import { CONTACT_EMAIL } from '~/constants';

export const Error: React.FC = () => {
  return (
    <Box background="error.100" padding={4} borderRadius={8} minHeight={15}>
      <Flex gap={2}>
        <Box as="span">
          <InfoCircleIcon boxSize={4} />
        </Box>
        <Flex direction="column">
          <Text fontSize="lg" fontWeight="500" color="primary.700">
            We've encountered an error.
          </Text>
          <Text fontSize="lg">
            <Text fontWeight="400" color="primary.700">
              Please reload and try again. If the issue persists,{' '}
              <Link
                fontWeight="500"
                color="primary.700"
                textDecoration="underline"
                href={`mailto:${CONTACT_EMAIL}`}
              >
                contact us.
              </Link>
            </Text>
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};
